import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Container, Grid, Header} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Alert} from 'componentLibrary';
import {ENDPOINT_ANALYTICS} from 'common/endpoints';
import REST from 'go/requests/rest';
import _ from 'lodash';
import goStore from 'go/store';

export class Analytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };
  }

  componentDidMount() {
    this.getAnalytics();
  }

  renderAlert = (message) => {
    if (message) {
      return <Alert header={message} type="success" dismissable />;
    }
  };

  getAnalytics = () => {
    return REST.report
      .getAnalyticsReportsInfo(this.props.jwt)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        this.setState({
          analytics: resJson,
        });
      })
      .catch((error) => {
        console.error('error');
      });
  };

  renderAnalytics = () => {
    const {analytics} = this.state;
    const state = goStore.store.getState();
    const csrftoken = _.get(state, 'auth.token._csrftoken');
    return _.map(analytics, (reportCategory) => {
      return _.map(reportCategory.reports, (report) => {
        let payload = report.payload;
        return (
          <Grid.Column>
            <Card>
              <Card.Content>
                <Header as="h3">{payload.name}</Header>

                <Card.Description>
                  <Link
                    to={`${ENDPOINT_ANALYTICS}report/${report.reportRefId}?_csrftoken=${csrftoken}`}
                    title={payload.description}
                    target="_blank"
                  >
                    Export to CSV
                  </Link>
                  <br />
                  <Link
                    to={`${ENDPOINT_ANALYTICS}reportMetadata/${report.reportRefId}?_csrftoken=${csrftoken}`}
                    title={payload.description}
                    target="_blank"
                  >
                    Export Data Catalog
                  </Link>
                </Card.Description>
              </Card.Content>
            </Card>
          </Grid.Column>
        );
      });
    });
  };

  render() {
    const {message} = this.state;

    return (
      <Main>
        <Container fluid>
          {this.renderAlert(message)}
          <Header as="h1">Reports Summary</Header>
          <Grid columns={4} doubling stackable padded="vertically">
            {this.renderAnalytics()}
          </Grid>
        </Container>
      </Main>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({});

export const mapStateToProps = (state) => {
  return {
    jwt: state.auth.token,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);
